import React, { useState } from "react";

const TAP_BREAKPOINT = 1024;

const BuyerCardFeatured = ({ buyer }) => {
  const [expanded, setExpanded] = useState(false);
  const titleId = `abr-bc-${buyer.id}-title`;

  const toggleExpanded = () => {
    if (typeof window === "undefined") return;
    if (window.innerWidth > TAP_BREAKPOINT) return;
    setExpanded((prev) => !prev);
  };

  const onKeyDown = (e) => {
    if (typeof window === "undefined") return;
    if (window.innerWidth > TAP_BREAKPOINT) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setExpanded((prev) => !prev);
    }
  };

  const cls = `abr-buyer-card${buyer.topTag ? " is-top" : ""}${expanded ? " is-expanded" : ""}`;

  return (
    <article
      className={cls}
      aria-labelledby={titleId}
      tabIndex={0}
      onClick={toggleExpanded}
      onKeyDown={onKeyDown}
    >
      <div className="abr-bc-top">
        <div className="abr-bc-id" id={titleId}>
          #{buyer.id}
          {buyer.topTag ? <span className="abr-bc-tag">Top match</span> : null}
        </div>
        <div className="abr-bc-score">
          {buyer.score}
          <span className="abr-bc-score-pct">%</span>
        </div>
      </div>
      {buyer.story ? <div className="abr-bc-story">{buyer.story}</div> : null}
      {buyer.signals && buyer.signals.length ? (
        <div className="abr-bc-signals">
          {buyer.signals.map((sig, idx) => (
            <span key={idx} className={`abr-bc-sig${sig.strong ? " is-strong" : ""}`}>
              {sig.label}
            </span>
          ))}
        </div>
      ) : null}
      <div className="abr-bc-extra">
        <div className="abr-bc-crit">
          <div>
            <div className="abr-bc-crit-lbl">Budget</div>
            <div className="abr-bc-crit-val">{buyer.budgetDisplay}</div>
          </div>
          <div>
            <div className="abr-bc-crit-lbl">Timeline</div>
            <div className="abr-bc-crit-val">{buyer.timelineDisplay}</div>
          </div>
        </div>
        {buyer.musts && buyer.musts.length ? (
          <div className="abr-bc-musts">
            {buyer.musts.map((m, idx) => (
              <span key={idx} className="abr-bc-must">{m}</span>
            ))}
          </div>
        ) : null}
        {buyer.why ? (
          <div className="abr-bc-why">
            <span className="abr-why-lbl">Why this matches</span>
            {buyer.why}
          </div>
        ) : null}
        {buyer.brokerage ? (
          <div className="abr-bc-rep">
            Agent at <strong>{buyer.brokerage}</strong>
          </div>
        ) : null}
      </div>
    </article>
  );
};

export default BuyerCardFeatured;
